import React from "react";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useMst } from "../../store/root";
import styles from "./Modal.module.scss";
import { ModalButton } from "../baseComponents";

export const AlertModal = observer(() => {
  const {
    uiStore: { alertModalVisible, setAlertModalHidden, alertMessage },
  } = useMst();

  return (
    <Modal
      className={styles.Modal}
      visible={alertModalVisible}
      onOk={() => setAlertModalHidden}
      onCancel={setAlertModalHidden}
      footer={false}
    >
      <h1>Notice!</h1>
      <p className={styles.AlertMessage}>{alertMessage}</p>
      <div className={styles.Buttons}>
        <ModalButton onClick={setAlertModalHidden} text="Ok" />
      </div>
    </Modal>
  );
});
